///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

const GridIcon = ({ height, fill, title = "Grid", width, ...rest }) => (
  <svg
    aria-labelledby="grid-icon"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="grid-icon">{title}</title>
    <path
      d="M13.396 3.999H.6c-.552 0-.6.447-.6 1 0 .552.048 1 .6 1h12.796c.552 0 .6-.448.6-1 0-.553-.048-1-.6-1zm0 3.998H.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h12.796c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zM.6 2h12.796c.552 0 .6-.446.6-1 0-.552-.048-.999-.6-.999H.6C.048 0 0 .447 0 1c0 .553.048 1 .6 1z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

export default GridIcon;
